import { render } from "./PersonDetail.vue?vue&type=template&id=f866e86e&scoped=true"
import script from "./PersonDetail.vue?vue&type=script&lang=js"
export * from "./PersonDetail.vue?vue&type=script&lang=js"

import "./PersonDetail.vue?vue&type=style&index=0&id=f866e86e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f866e86e"]])

export default __exports__